export default __webpack_public_path__ + "static/media/placeholder.980c1a61.svg";